<div class="chip" [ngClass]="[type, size]">
  <ng-content></ng-content>
</div>
